export default {
  plural: 'Зображення',
  singular: 'Зображення'
};
